__turbopack_context__.v({
  "error": "MW0ffG_error",
  "field": "MW0ffG_field",
  "footer": "MW0ffG_footer",
  "form": "MW0ffG_form",
  "honeypot": "MW0ffG_honeypot",
  "inlineLink": "MW0ffG_inlineLink",
  "input": "MW0ffG_input",
  "label": "MW0ffG_label",
  "noscript": "MW0ffG_noscript",
  "note": "MW0ffG_note",
  "optional": "MW0ffG_optional",
  "row": "MW0ffG_row",
  "select": "MW0ffG_select",
  "selectWrap": "MW0ffG_selectWrap",
  "status": "MW0ffG_status",
  "submit": "MW0ffG_submit",
  "success": "MW0ffG_success",
  "successBody": "MW0ffG_successBody",
  "successTitle": "MW0ffG_successTitle",
  "textarea": "MW0ffG_textarea",
});
